const Moon: React.FC = () => {
  return (
    <svg id="dark_mode_black_24dp" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 40 40">
      <rect id="Rectangle_16286" data-name="Rectangle 16286" width="40" height="40" fill="none" />
      <path
        id="Path_64622"
        data-name="Path 64622"
        d="M13.582,7.17a12.307,12.307,0,0,0,11.844,15.6,12.211,12.211,0,0,0,3.306-.449A11.631,11.631,0,1,1,13.582,7.17ZM17.951,3A14.951,14.951,0,1,0,32.9,17.951a16.814,16.814,0,0,0-.166-2.259A8.978,8.978,0,1,1,20.21,3.166,16.815,16.815,0,0,0,17.951,3Z"
        transform="translate(1.984 1.984)"
        fill="#8aa9ce"
      />
    </svg>
  );
};

export default Moon;
